'use client'

import classNames from 'classnames'
import { useState } from 'react'
import { Icon } from './Icon'

type HashTagProps = {
  text: string
  readonly?: boolean
  onClick?: (text: string) => void
  onDelete?: () => void
}

const HashTag = ({ text, readonly, onDelete, onClick }: HashTagProps) => {
  return (
    <div
      className={classNames(
        'text-body1 text-key cursor-pointer flex gap-2 items-center',
      )}
      onClick={() => onClick?.(text)}
    >
      <span>#{text}</span>
      {onDelete && (
        <Icon
          size={13}
          name="close"
          className="!text-gray-600"
          onClick={onDelete}
        />
      )}
    </div>
  )
}

type HashTagsProps = {
  tags: string[]
  readonly?: boolean
  onAdd?: (text: string) => void
  onDelete?: (index: number) => void
  onClick?: (text: string) => void
  className?: string
}

const HashTags = ({
  tags,
  readonly,
  onAdd,
  onDelete,
  onClick,
  className,
}: HashTagsProps) => {
  const [value, setValue] = useState('')

  const propagate = () => {
    if (!value) {
      return
    }

    if (tags.find((t) => t === value)) {
      setValue('')
      return
    }

    onAdd?.(value)
    setValue('')
  }

  const onChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value.replace(/#/g, ''))
  }

  return (
    <div className={classNames('flex gap-3 flex-wrap', className)}>
      {tags.map((tag, i) => {
        return (
          <HashTag
            // eslint-disable-next-line react/no-array-index-key
            key={tag + i}
            text={tag}
            readonly={readonly}
            onDelete={onDelete ? () => onDelete?.(i) : undefined}
            onClick={onClick}
          />
        )
      })}
      {onAdd && tags.length < 30 && (
        <div>
          <input
            placeholder="#해시태그"
            className="text-body2 leading-4 text-gray-900 placeholder:text-gray-500 min-w-0 appearance-none bg-transparent outline-none"
            onChange={onChangeInput}
            value={value}
            onBlur={propagate}
            onKeyDown={(e) => {
              if (e.key === 'Tab') {
                e.preventDefault()
                propagate()
              }
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault()
                propagate()
              }
            }}
          />
        </div>
      )}
    </div>
  )
}

export default HashTags
